export const departments = [
  {
    id: 1,
    minister: "Energy",
    dept: "Department of Energy",
    icon: "⚡",
    color: "#FFF3CD",
    iconColor: "#856404",
    payments: [
      { name: "Electricity bill (LT)", desc: "Low tension home & shop electricity bill payment", url: "https://www.tnebnet.org/awp/login", portalUrl: "https://www.tangedco.org/", portal: "TNEBNET", logo: "/logos/tnebnet.png" },
      { name: "Electricity bill (HT)", desc: "High tension industrial electricity bill payment", url: "https://www.tnebnet.org/awp/login", portalUrl: "https://www.tangedco.org/", portal: "TNEBNET", logo: "/logos/tnebnet.png" },
      { name: "New service connection", desc: "Pay fees for new electricity connection", url: "https://app1.tangedco.org/nsconline/", portal: "TANGEDCO", logo: null },
      { name: "Meter deposit & charges", desc: "Meter caution deposit, development charges", url: "https://app1.tangedco.org/nsconline/", portal: "TANGEDCO", logo: null },
    ]
  },
  {
    id: 2,
    minister: "Municipal Administration & Water Supply",
    dept: "Department of Municipal Administration & Water Supply",
    icon: "🏙️",
    color: "#D1ECF1",
    iconColor: "#0C5460",
    payments: [
      { name: "Chennai water tax", desc: "CMWSSB water bill and sewerage charges", url: "https://bnc.chennaimetrowater.in/#/public/cus-login", portalUrl: "https://www.chennaimetrowater.in/", portal: "CMWSSB", logo: "/logos/cmwssb.png" },
      { name: "Chennai property tax", desc: "Greater Chennai Corporation property tax", url: "https://chennaicorporation.gov.in/gcc/online-payment/property-tax/property-tax-online-payment/", portalUrl: "https://chennaicorporation.gov.in/", portal: "Chennai Corporation", logo: "/logos/gcc.png" },
      { name: "TN urban municipal tax", desc: "Property tax for all urban local bodies", url: "https://tnurbanepay.tn.gov.in", portal: "TN Urban ePay", logo: "/logos/tnurbanepay.png" },
      { name: "Coimbatore property & water tax", desc: "CCMC property and water tax payment", url: "https://tnurbanepay.tn.gov.in", portalUrl: "https://www.ccmc.gov.in/", portal: "CCMC", logo: "/logos/ccmc.png" },
      { name: "Madurai property tax", desc: "Madurai Corporation property tax", url: "https://tnurbanepay.tn.gov.in", portalUrl: "https://maduraicorporation.co.in/", portal: "TN Urban ePay", logo: "/logos/tnurbanepay.png" },
      { name: "Tiruchirappalli property tax", desc: "Trichy City Corporation property tax online payment", url: "https://www.trichycorporation.gov.in/propertytax", portalUrl: "https://www.trichycorporation.gov.in/", portal: "Trichy Corporation", logo: "/logos/trichy-corp.png" },
      { name: "Erode property & water tax", desc: "Erode City Municipal Corporation property and water tax", url: "https://tnurbanepay.tn.gov.in", portalUrl: "https://erodecorp.tn.gov.in/", portal: "TN Urban ePay", logo: "/logos/tnurbanepay.png" },
      { name: "Building plan approval fee", desc: "CMDA building plan and layout fees", url: "https://www.cmdachennai.gov.in/", portalUrl: "https://www.cmdachennai.gov.in/", portal: "CMDA", logo: null },
      { name: "Municipal professional tax", desc: "Professional tax for urban local bodies", url: "https://tnurbanepay.tn.gov.in", portal: "TN Urban ePay", logo: "/logos/tnurbanepay.png" },
      { name: "Trade license fee (urban)", desc: "Trade license renewal and new license in municipalities", url: "https://tnurbanepay.tn.gov.in", portal: "TN Urban ePay", logo: "/logos/tnurbanepay.png" },
      { name: "Underground drainage (UGD) tax", desc: "UGD connection and annual drainage tax", url: "https://tnurbanepay.tn.gov.in", portal: "TN Urban ePay", logo: "/logos/tnurbanepay.png" },
      { name: "Water & UGD deposit", desc: "New water/UGD connection deposit charges", url: "https://tnurbanepay.tn.gov.in", portal: "TN Urban ePay", logo: "/logos/tnurbanepay.png" },
    ]
  },
  {
    id: 3,
    minister: "Rural Development & Panchayat Raj",
    dept: "Department of Rural Development and Panchayat Raj",
    icon: "🌾",
    color: "#D4EDDA",
    iconColor: "#155724",
    payments: [
      { name: "Village panchayat property tax", desc: "Rural property tax for 12,525 village panchayats", url: "https://vptax.tnrd.tn.gov.in", portal: "VP Tax Portal", logo: "/logos/vptax.png" },
      { name: "Village panchayat water charges", desc: "Rural water supply charges", url: "https://vptax.tnrd.tn.gov.in", portal: "VP Tax Portal", logo: "/logos/vptax.png" },
      { name: "Village panchayat professional tax", desc: "Professional tax in rural areas", url: "https://vptax.tnrd.tn.gov.in", portal: "VP Tax Portal", logo: "/logos/vptax.png" },
      { name: "Trade license fee (rural)", desc: "Trade and shop license in village panchayats", url: "https://vptax.tnrd.tn.gov.in", portal: "VP Tax Portal", logo: "/logos/vptax.png" },
    ]
  },
  {
    id: 4,
    minister: "Commercial Taxes & Registration",
    dept: "Department of Commercial Taxes and Registration",
    icon: "🧾",
    color: "#F8D7DA",
    iconColor: "#721C24",
    payments: [
      { name: "Professional tax (employer)", desc: "Employer professional tax payment (urban local bodies)", url: "https://tnurbanepay.tn.gov.in", portalUrl: "https://tnurbanepay.tn.gov.in", portal: "TN Urban ePay", logo: "/logos/tnurbanepay.png" },
      { name: "Professional tax (employee)", desc: "Employee professional tax payment (urban local bodies)", url: "https://tnurbanepay.tn.gov.in", portalUrl: "https://tnurbanepay.tn.gov.in", portal: "TN Urban ePay", logo: "/logos/tnurbanepay.png" },
      { name: "VAT / commercial tax", desc: "Value added tax and commercial tax payments", url: "https://tnvat.tn.gov.in/wologin/", portalUrl: "https://tnvat.tn.gov.in/ctdportal/", portal: "TN CTD Portal", logo: null },
      { name: "VAT e-payment", desc: "Direct online VAT/CST payment portal", url: "https://tnvat.tn.gov.in/wologin/", portal: "TN VAT e-Pay", logo: null },
      { name: "GST tax payment", desc: "Create challan and pay GST online (national portal)", url: "https://payment.gst.gov.in/", portal: "GST Portal", logo: null },
      { name: "Stamp duty payment", desc: "Property stamp duty before registration", url: "https://tnregipayment.gov.in/regnepay/epay-citizen.jsp", portal: "TNREGINET", logo: "/logos/tnreginet.svg" },
      { name: "Property registration fee", desc: "Document registration charges", url: "https://tnregipayment.gov.in/regnepay/epay-citizen.jsp", portal: "TNREGINET", logo: "/logos/tnreginet.svg" },
      { name: "Chit fund registration", desc: "Chit fund company registration fees", url: "https://tnregipayment.gov.in/regnepay/epay-citizen.jsp", portal: "TNREGINET", logo: "/logos/tnreginet.svg" },
    ]
  },
  {
    id: 5,
    minister: "Transport",
    dept: "Department of Transport",
    icon: "🚗",
    color: "#E2D9F3",
    iconColor: "#432874",
    payments: [
      { name: "Road tax (vehicle)", desc: "Annual or lifetime road tax for vehicles", url: "https://vahan.parivahan.gov.in/", portal: "Vahan / TNSTA", logo: null },
      { name: "Driving license fee", desc: "DL application, renewal, test fees", url: "https://sarathi.parivahan.gov.in/sarathiservice/stateSelection.do", portal: "Sarathi", logo: null },
      { name: "Vehicle registration fee", desc: "New vehicle registration and RC charges", url: "https://vahan.parivahan.gov.in/", portal: "Vahan", logo: null },
      { name: "Fitness certificate fee", desc: "Commercial vehicle fitness certificate", url: "https://vahan.parivahan.gov.in/", portal: "Vahan", logo: null },
      { name: "Permit fee", desc: "Transport permit for commercial vehicles", url: "https://tnsta.gov.in/", portal: "TNSTA", logo: null },
      { name: "Traffic challan", desc: "Pay traffic violation fines online", url: "https://echallan.parivahan.gov.in/", portal: "Parivahan eChallan", logo: null },
    ]
  },
  {
    id: 6,
    minister: "Health & Family Welfare",
    dept: "Department of Health and Family Welfare",
    icon: "🏥",
    color: "#FDECEA",
    iconColor: "#7B241C",
    payments: [
      { name: "Drug license fee", desc: "Pharmacy and drug store license fees", url: "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm", portal: "SBI Collect", logo: null },
      { name: "Govt hospital charges", desc: "OPD, IPD, surgery charges at govt hospitals", url: "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm", portal: "SBI Collect", logo: null },
      { name: "Clinical establishment fee", desc: "Private clinic and hospital registration", url: "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm", portal: "SBI Collect", logo: null },
      { name: "TN health dept services", desc: "Health department licenses and scheme fees", url: "https://www.tnhealth.tn.gov.in/", portal: "TN Health Dept", logo: null },
    ]
  },
  {
    id: 7,
    minister: "School Education",
    dept: "Department of School Education",
    icon: "📚",
    color: "#FFF3CD",
    iconColor: "#533F03",
    payments: [
      { name: "Board exam fee (DGE)", desc: "10th and 12th board exam fees and registration", url: "https://dge.tn.gov.in/", portal: "DGE Tamil Nadu", logo: null },
      { name: "School certificate fee", desc: "TC, marksheet, migration certificate fees", url: "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm", portal: "SBI Collect", logo: null },
    ]
  },
  {
    id: 8,
    minister: "Higher Education",
    dept: "Department of Higher Education",
    icon: "🎓",
    color: "#D1ECF1",
    iconColor: "#0A3D52",
    payments: [
      { name: "Anna University exam fee", desc: "Exam registration and fee payment for AU affiliated colleges", url: "https://coe.annauniv.edu/", portal: "AU COE Portal", logo: null },
      { name: "Bharathidasan University fee", desc: "Exam, admission and certificate fees for BDU students", url: "https://www.bdu.ac.in/online-payment/", portal: "BDU Online Payment", logo: null },
      { name: "Madras University fee", desc: "Exam and course fees for University of Madras students", url: "https://apps.indianbank.in/madrasuniv/", portal: "UNOM / Indian Bank", logo: null },
      { name: "Madurai Kamaraj University fee", desc: "Exam and course fee payment for MKU students", url: "https://mkuniversity.ac.in/", portal: "MKU", logo: null },
      { name: "Bharathiar University fee", desc: "Exam and admission fees for Bharathiar University", url: "https://b-u.ac.in/", portal: "Bharathiar University", logo: null },
      { name: "Periyar University fee", desc: "Exam and course fees for Periyar University students", url: "https://www.periyaruniversity.ac.in/", portal: "Periyar University", logo: null },
      { name: "Alagappa University fee", desc: "Exam and admission fees for Alagappa University", url: "https://www.alagappauniversity.ac.in/", portal: "Alagappa University", logo: null },
      { name: "TN Dr. MGR Medical University fee", desc: "Medical and allied health course exam fees", url: "https://www.tnmgrmu.ac.in/", portal: "TN MGR Medical Univ", logo: null },
      { name: "College admission fee", desc: "Govt college admission and tuition fees via SBI Collect", url: "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm", portal: "SBI Collect", logo: null },
      { name: "TANCET application fee", desc: "Tamil Nadu Common Entrance Test fee", url: "https://tancet.annauniv.edu/", portal: "Anna University", logo: null },
    ]
  },
  {
    id: 9,
    minister: "Labour & Employment",
    dept: "Department of Labour and Employment",
    icon: "👷",
    color: "#E2D9F3",
    iconColor: "#3B1F6B",
    payments: [
      { name: "Factory license fee", desc: "Factory registration and renewal under Factories Act", url: "https://labour.tn.gov.in/", portal: "Labour Dept TN", logo: "/logos/labour.png" },
      { name: "Boiler certificate fee", desc: "Boiler inspection and certificate charges", url: "https://labour.tn.gov.in/", portal: "Labour Dept TN", logo: "/logos/labour.png" },
      { name: "Shops & establishment fee", desc: "Shop registration and renewal fee", url: "https://labour.tn.gov.in/", portal: "Labour Dept TN", logo: "/logos/labour.png" },
      { name: "ESI contribution", desc: "Employee State Insurance contributions", url: "https://www.esic.gov.in/", portal: "ESIC", logo: "/logos/esic.jpg" },
      { name: "PF contribution", desc: "Provident fund employer contributions", url: "https://www.epfo.gov.in/", portal: "EPFO", logo: "/logos/epfo.png" },
    ]
  },
  {
    id: 10,
    minister: "Industries",
    dept: "Department of Industries",
    icon: "🏭",
    color: "#D4EDDA",
    iconColor: "#1A5C30",
    payments: [
      { name: "MSME registration fee", desc: "Udyam registration and certificate fee", url: "https://udyamregistration.gov.in/", portal: "Udyam", logo: "/logos/udyam.png" },
      { name: "Single window approvals", desc: "200+ business clearances and NOC fees", url: "https://tnswp.com/", portal: "TN Single Window", logo: "/logos/tnswp.png" },
      { name: "Industries dept NOC", desc: "Pollution NOC, fire NOC for industries", url: "https://tnswp.com/", portal: "TN Single Window", logo: "/logos/tnswp.png" },
    ]
  },
  {
    id: 11,
    minister: "Home, Prohibition & Excise",
    dept: "Department of Home, Prohibition and Excise",
    icon: "🏛️",
    color: "#F8D7DA",
    iconColor: "#5C1A1A",
    payments: [
      { name: "Excise license fee", desc: "Liquor license, bar license fees — online via eKalaal portal", url: "https://ekalaal.tn.gov.in/", portal: "eKalaal (TN Excise)", logo: null },
      { name: "Police NOC fee", desc: "Police verification and NOC charges", url: "https://eservices.tn.gov.in/", portal: "TN eServices", logo: null },
      { name: "Arms license fee", desc: "Arms license application and renewal", url: "https://eservices.tn.gov.in/", portal: "TN eServices", logo: null },
    ]
  },
  {
    id: 12,
    minister: "Law",
    dept: "Department of Law",
    icon: "⚖️",
    color: "#FEF9E7",
    iconColor: "#7D6608",
    payments: [
      { name: "Court filing fee", desc: "Civil, criminal case filing fees in TN courts", url: "https://pay.ecourts.gov.in/", portal: "eCourts Pay", logo: "/logos/ecourts.png" },
      { name: "Court fine payment", desc: "Pay court-imposed fines and penalties", url: "https://pay.ecourts.gov.in/", portal: "eCourts Pay", logo: "/logos/ecourts.png" },
      { name: "Notary & advocate fee", desc: "Govt notary and legal service fees", url: "https://pay.ecourts.gov.in/", portal: "eCourts Pay", logo: "/logos/ecourts.png" },
    ]
  },
  {
    id: 13,
    minister: "Revenue & Disaster Management",
    dept: "Department of Revenue and Disaster Management",
    icon: "📋",
    color: "#EDE7F6",
    iconColor: "#4A148C",
    payments: [
      { name: "Land revenue / patta fee", desc: "Land record, patta, chitta application fees", url: "https://eservices.tn.gov.in/", portal: "TN eServices", logo: null },
      { name: "Certificate application fee", desc: "Community, income, nativity certificates", url: "https://eservices.tn.gov.in/", portal: "TN eServices", logo: null },
      { name: "Land survey fee", desc: "Survey and settlement department fees", url: "https://eservices.tn.gov.in/", portal: "TN eServices", logo: null },
      { name: "e-District services", desc: "Revenue certificates, pensions, and scheme applications with online payment", url: "https://tnedistrict.tn.gov.in/", portal: "TN e-District", logo: null },
      { name: "Differently abled pension (DAPS)", desc: "REV-206 pension scheme application and fee via e-District", url: "https://www.tnesevai.tn.gov.in/Default.aspx", portal: "e-Sevai Citizen", logo: "/logos/tnesevai.png" },
    ]
  },
  {
    id: 14,
    minister: "Tourism, Culture & Religious Endowments",
    dept: "Department of Tourism, Culture and Religious Endowments",
    icon: "🛕",
    color: "#FFF8E1",
    iconColor: "#6D4C00",
    payments: [
      { name: "Temple donation (HR&CE)", desc: "Donations to Hindu Religious & Charitable Endowments temples", url: "https://hrce.tn.gov.in/hrcehome/", portal: "HR&CE", logo: null },
      { name: "Temple booking fee", desc: "Special puja and darshan booking at temples", url: "https://hrce.tn.gov.in/hrcehome/", portal: "HR&CE", logo: null },
      { name: "Tourism dept fee", desc: "Guide license, resort registration fees", url: "https://www.tamilnadutourism.tn.gov.in/", portal: "TN Tourism", logo: "/logos/tn-tourism.webp" },
    ]
  },
  {
    id: 15,
    minister: "Finance",
    dept: "Department of Finance",
    icon: "💰",
    color: "#E8F5E9",
    iconColor: "#1B5E20",
    payments: [
      { name: "Treasury e-Challan (Karuvoolam)", desc: "Official TN treasury portal for all govt fee challans", url: "https://www.karuvoolam.tn.gov.in/challan/echallan", portal: "Karuvoolam", logo: null },
      { name: "Treasury payment (GRIPS)", desc: "State govt dues via SBI Collect / GRIPS", url: "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm", portal: "SBI Collect / GRIPS", logo: null },
      { name: "IFHRMS employee portal", desc: "Government employee payroll, leave and service records", url: "https://www.karuvoolam.tn.gov.in/", portal: "Karuvoolam IFHRMS", logo: null },
      { name: "Pensioner portal", desc: "Pension statements and payment history for TN govt pensioners", url: "https://www.karuvoolam.tn.gov.in/", portal: "Karuvoolam Pension", logo: null },
    ]
  },
  {
    id: 16,
    minister: "Housing & Urban Development",
    dept: "Department of Housing and Urban Development",
    icon: "🏠",
    color: "#E3F2FD",
    iconColor: "#0D47A1",
    payments: [
      { name: "TNHB flat booking fee", desc: "TN Housing Board flat application and EMD", url: "https://tnhb.tn.gov.in/", portal: "TNHB", logo: null },
      { name: "Building plan fee (CMDA)", desc: "Building plan approval, layout permission", url: "https://www.cmdachennai.gov.in/", portalUrl: "https://www.cmdachennai.gov.in/", portal: "CMDA", logo: null },
      { name: "TNUHDB housing fee", desc: "TN Urban Habitat Development Board housing application fees", url: "https://www.tnuhdb.tn.gov.in/", portal: "TNUHDB", logo: null },
    ]
  },
  {
    id: 17,
    minister: "Agriculture",
    dept: "Department of Agriculture and Farmers Welfare",
    icon: "🌱",
    color: "#F1F8E9",
    iconColor: "#33691E",
    payments: [
      { name: "Pesticide license fee", desc: "Pesticide dealer license registration and renewal", url: "https://www.tnagrisnet.tn.gov.in/esevai/", portal: "Agri e-Sevai", logo: "/logos/tnau.jpg" },
      { name: "Fertilizer dealer license", desc: "Fertilizer retailer license registration fee", url: "https://www.tnagrisnet.tn.gov.in/esevai/", portal: "Agri e-Sevai", logo: null },
      { name: "TANSEDA payment", desc: "Agriculture department seed and input scheme payments", url: "https://tnagrisnet.tn.gov.in/tops/", portal: "TANSEDA", logo: null },
      { name: "Seed certification fee", desc: "Seed testing and certification charges", url: "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm", portal: "SBI Collect", logo: null },
      { name: "PM-KISAN related payments", desc: "Farmer scheme application and status", url: "https://pmkisan.gov.in/", portal: "PM-KISAN", logo: null },
    ]
  },
  {
    id: 18,
    minister: "Co-operation, Food & Consumer Protection",
    dept: "Department of Co-operation, Food and Consumer Protection",
    icon: "🛒",
    color: "#FBE9E7",
    iconColor: "#BF360C",
    payments: [
      { name: "Ration card service fee", desc: "Smart ration card application charges", url: "https://www.tnpds.gov.in/", portal: "TNPDS", logo: "/logos/tnpds.png" },
      { name: "Fair price shop license", desc: "PDS shop license and renewal fees", url: "https://www.tnpds.gov.in/", portal: "TNPDS", logo: "/logos/tnpds.png" },
    ]
  },
  {
    id: 19,
    minister: "Micro, Small & Medium Enterprises",
    dept: "Department of Micro, Small and Medium Enterprises",
    icon: "🔧",
    color: "#E8EAF6",
    iconColor: "#1A237E",
    payments: [
      { name: "MSME loan application fee", desc: "TANSIDCO loan application fees", url: "https://www.tansidco.tn.gov.in/", portal: "TANSIDCO", logo: "/logos/tansidco.png" },
      { name: "Industrial plot booking", desc: "SIPCOT plot booking fee, EMD and processing charges", url: "https://sipcotweb.tn.gov.in/", portal: "SIPCOT", logo: "/logos/sipcot.gif" },
      { name: "TIDCO industrial services", desc: "TIDCO industrial infrastructure and plot services", url: "https://www.tidco.com/", portal: "TIDCO", logo: null },
    ]
  },
  {
    id: 20,
    minister: "Highways & Minor Ports",
    dept: "Department of Highways and Minor Ports",
    icon: "🛣️",
    color: "#EFEBE9",
    iconColor: "#4E342E",
    payments: [
      { name: "FASTag recharge", desc: "FASTag wallet top-up for toll payments", url: "https://fastag.ihmcl.com/", portal: "IHMCL FASTag", logo: null },
      { name: "Tender fee (highways)", desc: "Road and infrastructure tender EMD", url: "https://tntenders.gov.in/", portal: "TN Tenders", logo: null },
    ]
  },
  {
    id: 21,
    minister: "Environment and Forests",
    dept: "Department of Environment and Forests",
    icon: "🌳",
    color: "#E0F2E9",
    iconColor: "#1B5E20",
    payments: [
      { name: "Forest produce fee", desc: "Timber and forest produce transit pass fees", url: "https://www.forests.tn.gov.in/", portal: "TN Forest Dept", logo: "/logos/tn-forests.png" },
      { name: "Pollution control consent fee", desc: "TNPCB consent to establish / operate fees", url: "https://ocmms.tn.gov.in/OCMMS/", portal: "TNPCB", logo: "/logos/tnpcb.png" },
      { name: "Lift / escalator inspection fee", desc: "Electrical inspectorate fees via treasury e-Challan", url: "https://www.karuvoolam.tn.gov.in/challan/echallan", portal: "Karuvoolam", logo: null },
    ]
  },
  {
    id: 22,
    minister: "Information Technology and Digital Services",
    dept: "Department of Information Technology and Digital Services",
    icon: "💻",
    color: "#E1F0FF",
    iconColor: "#0B4DA2",
    payments: [
      { name: "e-Sevai center service fee", desc: "Certificate and document services via e-Sevai centers", url: "https://www.tnesevai.tn.gov.in/Default.aspx", portal: "e-Sevai", logo: "/logos/tnesevai.png" },
      { name: "e-Sevai citizen portal", desc: "Self-service govt applications with online payment", url: "https://www.tnesevai.tn.gov.in/Default.aspx", portal: "e-Sevai Citizen", logo: "/logos/tnesevai.png" },
      { name: "TN e-District portal", desc: "District-level certificates and scheme services", url: "https://tnedistrict.tn.gov.in/", portal: "TN e-District", logo: null },
      { name: "CSC digital service fee", desc: "Common Service Centre e-governance services", url: "https://digitalseva.csc.gov.in/", portal: "CSC Digital Seva", logo: "/logos/csc.png" },
    ]
  },
  {
    id: 23,
    minister: "Handlooms, Handicrafts, Textiles and Khadi",
    dept: "Department of Handlooms, Handicrafts, Textiles and Khadi",
    icon: "🧵",
    color: "#FCE4EC",
    iconColor: "#880E4F",
    payments: [
      { name: "Co-optex showroom booking", desc: "Co-optex order and booking payments", url: "https://www.cooptex.com/", portal: "Co-optex", logo: null },
    ]
  },
  {
    id: 24,
    minister: "Public Works",
    dept: "Department of Public Works",
    icon: "🏗️",
    color: "#EDE0D4",
    iconColor: "#5D4037",
    payments: [
      { name: "PWD tender fee", desc: "Public works tender EMD and document fees", url: "https://tntenders.gov.in/", portal: "TN Tenders", logo: null },
      { name: "Building lease/rent payment", desc: "Government building rent and lease payments", url: "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm", portal: "SBI Collect", logo: null },
    ]
  },
  {
    id: 25,
    minister: "Water Resources",
    dept: "Department of Water Resources",
    icon: "🌊",
    color: "#E0F7FA",
    iconColor: "#00838F",
    payments: [
      { name: "Water resources tender fee", desc: "Irrigation and water project tender EMD", url: "https://tntenders.gov.in/", portal: "TN Tenders", logo: null },
      { name: "Water usage charges", desc: "Irrigation water cess and usage charges", url: "https://sbcollect.sbi.bank.in/sbicollect/icollecthome.htm", portal: "SBI Collect", logo: null },
    ]
  },
  {
    id: 26,
    minister: "Animal Husbandry, Dairying, Fisheries",
    dept: "Department of Animal Husbandry, Dairying, Fisheries and Fishermen Welfare",
    icon: "🐟",
    color: "#E8F5E9",
    iconColor: "#2E7D32",
    payments: [
      { name: "Aavin milk card renewal", desc: "Monthly Aavin milk subscription payment (1st–12th each month)", url: "https://aavin.tn.gov.in/", portal: "Aavin IDMS", logo: null },
      { name: "Aavin milk card registration", desc: "New Aavin milk card online registration", url: "https://aavin.tn.gov.in/", portal: "Aavin IDMS", logo: null },
      { name: "Fisheries dept services", desc: "Fishing license forms, welfare schemes and harbour services", url: "https://www.fisheries.tn.gov.in/", portal: "TN Fisheries", logo: null },
    ]
  },
  {
    id: 27,
    minister: "Youth Welfare & Sports",
    dept: "Department of Youth Welfare and Sports Development",
    icon: "🏅",
    color: "#FFF3E0",
    iconColor: "#E65100",
    payments: [
      { name: "SDAT sports registration", desc: "Player, coach and public registration for TN sports events", url: "https://www.tnsports.org.in/webapp/login.aspx", portal: "SDAT Aadukalam", logo: null },
      { name: "Sports facility booking", desc: "Government sports infrastructure and tournament fees", url: "https://www.tnsports.org.in/webapp/cms_home.aspx", portal: "SDAT", logo: null },
    ]
  },
  {
    id: 28,
    minister: "Social Welfare & Women Empowerment",
    dept: "Department of Social Welfare and Women Empowerment",
    icon: "💜",
    color: "#F3E5F5",
    iconColor: "#6A1B9A",
    payments: [
      { name: "Marriage assistance scheme", desc: "Moovalur Ramamirtham and related marriage assistance via e-Sevai", url: "https://www.tnesevai.tn.gov.in/Default.aspx", portal: "e-Sevai Citizen", logo: "/logos/tnesevai.png" },
      { name: "Girl child protection scheme", desc: "Girl child welfare scheme application and service fee", url: "https://www.tnesevai.tn.gov.in/Default.aspx", portal: "e-Sevai Citizen", logo: "/logos/tnesevai.png" },
      { name: "Widow remarriage assistance", desc: "Dharmambal Ammaiyar widow remarriage assistance scheme", url: "https://www.tnesevai.tn.gov.in/Default.aspx", portal: "e-Sevai Citizen", logo: "/logos/tnesevai.png" },
      { name: "Social welfare commissionerate", desc: "Social welfare schemes and programme information", url: "https://www.scd.tn.gov.in/", portal: "TN Social Welfare", logo: null },
    ]
  },
  {
    id: 29,
    minister: "Differently Abled Welfare",
    dept: "Department of Welfare of Differently Abled Persons",
    icon: "♿",
    color: "#E3F2FD",
    iconColor: "#1565C0",
    payments: [
      { name: "Assistive devices application", desc: "Apply for wheelchairs, hearing aids and assistive devices", url: "https://www.tnesevai.tn.gov.in/Default.aspx", portal: "e-Sevai Citizen", logo: "/logos/tnesevai.png" },
      { name: "Maintenance allowance scheme", desc: "Monthly maintenance allowance for differently abled persons", url: "https://www.tnesevai.tn.gov.in/Default.aspx", portal: "e-Sevai Citizen", logo: "/logos/tnesevai.png" },
      { name: "Differently abled welfare dept", desc: "Commissionerate for welfare of differently abled persons", url: "https://www.scd.tn.gov.in/", portal: "TN Differently Abled", logo: null },
    ]
  },
  {
    id: 30,
    minister: "Adi Dravidar & Tribal Welfare",
    dept: "Department of Adi Dravidar and Tribal Welfare",
    icon: "🤝",
    color: "#EFEBE9",
    iconColor: "#4E342E",
    payments: [
      { name: "ADTW scholarship portal", desc: "Post-matric scholarship for Adi Dravidar and Tribal students", url: "https://tnadtwscholarship.tn.gov.in/", portal: "ADTW Scholarship", logo: null },
      { name: "Tribal welfare schemes", desc: "Tribal student scholarships via e-District", url: "https://tnedistrict.tn.gov.in/", portal: "TN e-District", logo: null },
    ]
  },
  {
    id: 31,
    minister: "BC, MBC & Minorities Welfare",
    dept: "Department of Backward Classes, Most Backward Classes and Minorities Welfare",
    icon: "👥",
    color: "#E8EAF6",
    iconColor: "#283593",
    payments: [
      { name: "BC/MBC scholarship portal", desc: "Post-matric scholarship for BC, MBC and DNC students", url: "https://bcmbcmw.tn.gov.in/", portal: "BCMBCMW", logo: null },
      { name: "BC MBC welfare schemes", desc: "Welfare schemes for backward classes and minorities", url: "https://bcmbcmw.tn.gov.in/", portal: "BCMBCMW", logo: null },
      { name: "Minority institution status fee", desc: "Minority status conferment for educational institutions", url: "https://www.minoritystatus.tn.gov.in/", portal: "Minority Status Portal", logo: null },
    ]
  },
  {
    id: 32,
    minister: "Natural Resources",
    dept: "Department of Natural Resources",
    icon: "⛏️",
    color: "#EFEBE9",
    iconColor: "#5D4037",
    payments: [
      { name: "Mining & geology dept", desc: "Quarry lease, mineral exploration and royalty information", url: "https://tnmines.tn.gov.in/", portal: "TN Geology & Mining", logo: null },
      { name: "Mining lease application fee", desc: "Minor mineral quarry lease EMD and application via treasury", url: "https://www.karuvoolam.tn.gov.in/challan/echallan", portal: "Karuvoolam", logo: null },
    ]
  },
  {
    id: 33,
    minister: "Human Resources Management",
    dept: "Department of Human Resources Management",
    icon: "📊",
    color: "#ECEFF1",
    iconColor: "#37474F",
    payments: [
      { name: "IFHRMS employee services", desc: "Employee leave, payroll and service book management", url: "https://www.karuvoolam.tn.gov.in/", portal: "Karuvoolam IFHRMS", logo: null },
      { name: "HR challan payment", desc: "Government employee-related treasury challan payments", url: "https://www.karuvoolam.tn.gov.in/challan/echallan", portal: "Karuvoolam", logo: null },
    ]
  },
  {
    id: 34,
    minister: "Planning & Special Initiatives",
    dept: "Department of Planning, Development and Special Initiatives",
    icon: "📈",
    color: "#E8F5E9",
    iconColor: "#388E3C",
    payments: [
      { name: "Building plan permission fee", desc: "Online building plan and layout approval with payment", url: "https://www.cmdachennai.gov.in/", portal: "TN Planning Portal", logo: null },
      { name: "Planning project tender fee", desc: "Special initiative project tender EMD", url: "https://tntenders.gov.in/", portal: "TN Tenders", logo: null },
    ]
  },
  {
    id: 35,
    minister: "Tamil Development & Information",
    dept: "Department of Tamil Development and Information",
    icon: "📖",
    color: "#FFF8E1",
    iconColor: "#F57F17",
    payments: [
      { name: "Tamil publication & certificate fee", desc: "Tamil development dept publication and certificate services via e-Sevai", url: "https://www.tnesevai.tn.gov.in/Default.aspx", portal: "e-Sevai Citizen", logo: "/logos/tnesevai.png" },
    ]
  },
  {
    id: 36,
    minister: "Social Reforms",
    dept: "Department of Social Reforms",
    icon: "🕊️",
    color: "#FCE4EC",
    iconColor: "#AD1457",
    payments: [
      { name: "Intercaste marriage assistance", desc: "Dr. Muthulakshmi Reddy intercaste marriage assistance scheme", url: "https://www.tnesevai.tn.gov.in/Default.aspx", portal: "e-Sevai Citizen", logo: "/logos/tnesevai.png" },
      { name: "Social reforms scheme fees", desc: "Social reform welfare schemes via e-Sevai centres", url: "https://www.tnesevai.tn.gov.in/Default.aspx", portal: "e-Sevai", logo: "/logos/tnesevai.png" },
    ]
  },
  {
    id: 37,
    minister: "Public (Elections)",
    dept: "Department of Public (Elections)",
    icon: "🗳️",
    color: "#E3F2FD",
    iconColor: "#0D47A1",
    payments: [
      { name: "Election candidate deposit", desc: "Candidate security deposit and election fee (ECI national portal)", url: "https://www.eci.gov.in/", portal: "Election Commission", logo: null },
    ]
  },
];
